import * as React from "react";
import { Icon, IconName, TextColor, IconSize, MediaObject } from "@root/shared";

export const LoginLogo: React.FunctionComponent<{ className: string }> = ({ className }) => (
  <MediaObject>
    <Icon icon={IconName.AppCenterWhite} color={TextColor.White} size={IconSize.XLarge} className={className} />
  </MediaObject>
);
